"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

/** Centered glass card used by the public invite + join acceptance views. */
export function InviteShell({ children }: { children: React.ReactNode }) {
  const $t = useTranslations();
  return (
    <div className="relative flex min-h-[100dvh] flex-col items-center justify-center px-4">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 bg-cover bg-center opacity-40"
        style={{
          backgroundImage: "url('/images/wallpapers/bands_gradient_black.png')",
        }}
      />
      <div className="relative z-10 w-full max-w-sm">
        <div className="mb-8 flex justify-center">
          <Image
            src="/images/logos/text_w_logo_white.webp"
            alt={$t("organizations.aikodo")}
            width={120}
            height={36}
            priority
          />
        </div>
        <div className="rounded-3xl border border-white/10 bg-content1/70 p-6 shadow-2xl backdrop-blur-xl">
          {children}
        </div>
      </div>
    </div>
  );
}
